export default __webpack_public_path__ + "static/media/轮播首图13.75fec47a.png";